export const BoxCorner = {
  bindings: {
    icon: '@',
  },

  template: `
    <div class="box-corner theme-box-corner">
      <i class="fa fa-{{ $ctrl.icon }} fa--box-corner"></i>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Box/BoxCorner.js